// ADMIN
export const ADMIN_LOGOUT = "ADMIN_LOGOUT"

export const ADMIN_LOGIN_REQUEST = "ADMIN_LOGIN_REQUEST"
export const ADMIN_LOGIN_SUCCESS = "ADMIN_LOGIN_SUCCESS"
export const ADMIN_LOGIN_ERROR = "ADMIN_LOGIN_ERROR"

export const ADMIN_BILLING_REQUEST = "ADMIN_BILLING_REQUEST"
export const ADMIN_BILLING_SUCCESS = "ADMIN_BILLING_SUCCESS"
export const ADMIN_BILLING_ERROR = "ADMIN_BILLING_ERROR"

export const ADMIN_OWNER_INFO_UPDATE_REQUEST = "ADMIN_OWNER_INFO_UPDATE_REQUEST"
export const ADMIN_OWNER_INFO_UPDATE_SUCCESS = "ADMIN_OWNER_INFO_UPDATE_SUCCESS"
export const ADMIN_OWNER_INFO_UPDATE_ERROR = "ADMIN_OWNER_INFO_UPDATE_ERROR"
export const ADMIN_OWNER_INFO_UPDATE_INCOMPLETE = "ADMIN_OWNER_INFO_UPDATE_INCOMPLETE"
export const ADMIN_OWNER_INFO_RESET = "ADMIN_OWNER_INFO_RESET"
